<div class="flex w-full h-full p-6 gap-6 bg-surface-50 overflow-auto">
  <div class="flex-1 min-w-96 flex flex-col">
    <p-card>
      <div class="w-fit h-fit bg-white rounded-lg mb-4">
        <p-splitbutton outlined severity="secondary" size="small" label="Business Central Export"
                       [icon]="exporting() ? 'fa-regular fa-spinner fa-spin' : 'fa-regular fa-file-export'"
                       [model]="exportMenu" [disabled]="exporting()" (onClick)="exportBusinessCentral(false)"></p-splitbutton>
      </div>

      <p-tabs [value]="tabOption()" lazy (valueChange)="onTabChange($any($event))">
        <div class="bg-white rounded-t-lg w-fit max-w-full min-w-0">
          <p-tablist class="w-fit max-w-full min-w-0">
            @for (tab of financeTabs; track tab.value) {
              <p-tab [value]="tab.value" [attr.data-testid]="'finance-tab-' + tab.value">
                <div class="flex items-center gap-2">
                  <span class="text-nowrap">{{tab.label}}</span>
                  @if ((tabCount(tab) ?? 0) > 0) {
                    <p-badge [value]="tabCount(tab)" severity="danger" badgeSize="small"></p-badge>
                  }
                  @if (tab.value === "searchAll") {
                    <i class="fa-light fa-magnifying-glass"></i>
                  }
                </div>
              </p-tab>
            }
          </p-tablist>
        </div>

        <p-tabpanels class="rounded-b-lg rounded-tr-lg">
          <p-tabpanel value="payment">
            <div scrollHeight [bottomPadding]="60" class="flex flex-col gap-8 overflow-auto">
              <finance-requires-action-list [availableListInput]="requiresFinalisationList()"
                                            (finaliseTaClicked)="finaliseTaClicked($event)"
                                            (finaliseSelectedClicked)="finaliseSelectedTasClicked($event)"></finance-requires-action-list>
            </div>
          </p-tabpanel>
          <p-tabpanel value="prepaid">
            <div scrollHeight [bottomPadding]="60" class="flex flex-col gap-8 overflow-auto">
              <finance-paid-in-advance-list [availableListInput]="paidInAdvanceList()"
                                            (processPrepaymentTaClicked)="processPrepaymentTaClicked($event)"
                                            (processSelectedPrepaymentsClicked)="processSelectedPrepaymentsClicked($event)"></finance-paid-in-advance-list>
            </div>
          </p-tabpanel>
          <p-tabpanel value="stale">
            <div scrollHeight [bottomPadding]="60" class="flex flex-col gap-8 overflow-auto">
              <overdue-approvals-list [availableListInput]="overdueApprovalsList()" (overrideApproversClicked)="overrideApproversClicked($event)"></overdue-approvals-list>
            </div>
          </p-tabpanel>
          <p-tabpanel value="searchAll">
<!--        This if statement allows lazy loading to work for this tab    -->
            @if (tabOption() === 'searchAll') {
              <all-submissions-search></all-submissions-search>
            }
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </p-card>
    <div class="p-2.5 w-full"></div>
  </div>
  <div class="flex flex-col gap-6 max-w-1/4 w-fit">
    <ta-info-card [infoContext]="'finance'" [selectedTa]="selectedTa()" [costView]="tabOption() === 'payment' ? 'finalisation' : tabOption() === 'prepaid' ? 'prepayment' : undefined" [scheduledPaymentDate]="scheduledPaymentDate()"(actionTa)="taActionClicked($event, selectedTa())"></ta-info-card>
  </div>
</div>
